<template>
	<div>
		<video ref="videoPlayer" controls preload="auto" class="video-js"></video>
	</div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css'

export default {
	name: 'VideoPlayer',
	props: {
		options: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			player: null
		}
	},
	mounted() {
		this.player = videojs(this.$refs.videoPlayer, this.options, () => {
			this.player.log('onPlayerReady', this);
			this.player.controlBar.addChild('PlaybackRateMenuButton', {}, 0);
		});
	},
	beforeDestroy() {
		if (this.player) {
			this.player.dispose();
		}
	}
}
</script>

<style>
video,
.video-js {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>